import { CipherType } from '../../web-sh/src/core-js/src/enums';
import { CipherRequest } from '../../web-sh/src/core-js/src/models/request';

import {
  CipherView,
  LoginView,
  LoginUriView,
} from '../../web-sh/src/core-js/src/models/view';

import global from '../../config/global';

const createEncryptedMasterPw = async (masterPw, encKey = null) => {
  const cipher = new CipherView()
  cipher.type = CipherType.Login
  const loginData = new LoginView()
  loginData.username = 'locker.io';
  loginData.password = masterPw
  const uriView = new LoginUriView()
  uriView.uri = 'https://locker.io',
  loginData.uris = [uriView]
  cipher.login = loginData
  cipher.name = 'Locker Master Password'
  const cipherEnc = await global.jsCore.cipherService.encrypt(cipher, encKey)
  const data = new CipherRequest(cipherEnc)
  data.type = CipherType.MasterPassword
  return data
}

export default {
  createEncryptedMasterPw
}